import { render, staticRenderFns } from "./MenuBarFavoritesPagination.vue?vue&type=template&id=0924b39d&"
import script from "./MenuBarFavoritesPagination.vue?vue&type=script&lang=js&"
export * from "./MenuBarFavoritesPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports